import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Keyboard } from 'swiper/modules';
import { SWIPER_CONFIG } from '../config/swiper';

// Add modules
Swiper.use([
    Navigation,
    Pagination,
    Autoplay,
    Keyboard,
]);

// Instantiate
const swiperElements = Array.from(document.querySelectorAll('.swiper'));
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const initSwiper = (element) => {
    const dataConfig = JSON.parse(element.dataset?.config || '{}');

    if (prefersReducedMotion) {
        dataConfig.autoplay = false;
    }

    return new Swiper(element, {
        ...SWIPER_CONFIG,
        ...dataConfig,
        // Vanilla JS config
        ...{
            navigation: {
                nextEl: `#${element.id}-next`,
                prevEl: `#${element.id}-prev`,
                ...dataConfig?.navigation,
            },
            pagination: {
                el: `#${element.id}-pagination`,
                clickable: true,
                ...dataConfig?.pagination,
            }
        },
    });
}


swiperElements.forEach((element) => {
    initSwiper(element);
});
